import * as tslib_1 from "tslib";
import { NgZone, OnDestroy, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { ColorProvider } from '@components/ui-chart/chart-color-provider';
import { ColorService } from '@services/color/color.service';
import { Subscription } from 'rxjs';
var ThemeColorProvider = /** @class */ (function (_super) {
    tslib_1.__extends(ThemeColorProvider, _super);
    function ThemeColorProvider(appState, colorService, zone) {
        var _this = _super.call(this, zone) || this;
        _this.textColor = '';
        _this.tooltipTextColor = '';
        _this.tooltipBackgroundColor = '';
        _this.legendTextColor = '';
        _this.legendInactiveColor = '';
        _this.axisTextColor = '';
        _this.axisLineColor = '';
        _this.gridLineColor = '';
        _this.axisHoverColor = '';
        _this._themeSub = appState.user.theme.value$
            .subscribe(function () {
            _this.textColor = colorService.theme.material.foreground.text;
            _this.tooltipTextColor = colorService.theme.material.foreground.text;
            _this.tooltipBackgroundColor = colorService.theme.uipath.tooltip;
            _this.legendTextColor = colorService.theme.material.foreground.text;
            _this.legendInactiveColor = colorService.theme.material.foreground.disabledText;
            _this.axisTextColor = colorService.theme.material.foreground.text;
            _this.axisLineColor = colorService.theme.material.foreground.divider;
            _this.gridLineColor = colorService.theme.material.foreground.divider;
            _this.axisHoverColor = colorService.theme.material.background.hover;
            _this._changes.next();
        });
        return _this;
    }
    ThemeColorProvider.prototype.ngOnDestroy = function () {
        this.destroy();
        if (this._themeSub instanceof Subscription) {
            this._themeSub.unsubscribe();
        }
    };
    return ThemeColorProvider;
}(ColorProvider));
export { ThemeColorProvider };
